import Phaser from 'phaser'
import BootScene from '@/game/scenes/BootScene'
import PlayScene from '@/game/scenes/PlayScene'
import RexUIPlugin from 'phaser3-rex-plugins/templates/ui/ui-plugin.js';

const DEFAULT_WIDTH = 1200;
const DEFAULT_HEIGHT = 900;
const screenWidth = window.innerWidth;
const screenHeight = window.innerHeight;
const scale = Math.min(screenWidth/DEFAULT_WIDTH,screenHeight/DEFAULT_HEIGHT);

function launch(containerId) {
  return new Phaser.Game({
    dom: {
      createContainer: true,
      behindCanvas: true
    },
    //antialias:false,
    /*pixelArt:true,
    antialiasGL:false,
    antialias:false,*/
    /*pixelArt:false,
    antialias:false,
    antialiasGL:false,*/
    /*pixelArt:true,*/
    /*antialiasGL:false,*/
    /*resolution: 3,*/
    type: Phaser.AUTO,
    width: screenWidth,
    height: screenHeight,
    backgroundColor: '#32443d',
    //backgroundColor: 'transparent',
    parent: containerId,
    overflow: 'hidden',
    physics: {
      default: 'arcade',
      arcade: {
        debug: false
      }
    },
    scene: [BootScene, PlayScene],
    plugins: {
      scene: [{
          key: 'rexUI',
          plugin: RexUIPlugin,
          mapping: 'rexUI'
      }
      ]
  }
  })
}

export default launch
export { launch }
